<template>
	<div class="allBody">
		<div class="header">
			<div class="headerBg"></div>
			<div class="header1">
				<img class="header11" src="../assets/fuwuimg/logo.png" @click="gotoweb('/index')" />
			</div>
			<div class="header2">
				<div class="header2flex">
					<div class="header21" @click="gotoweb('/index')">首页<div class="imgg"
							:class="path == '/index' ? '' : 'yincang'"></div>
					</div>
					<div class="header21" @click="gotoweb('/serve')">服务<div class="imgg"
							:class="path == '/serve' ? '' : 'yincang'"></div>
					</div>
					<div class="header21" @click="gotoweb('/solution')">解决方案<div class="imgg"
							:class="path == '/solution' ? '' : 'yincang'"></div>
					</div>
					<div class="header21" @click="gotoweb('/successStories')">成功案例<div class="imgg"
							:class="path == '/successStories' ? '' : 'yincang'"></div>
					</div>
					<div class="header22 header21" @click="gotoweb('/aboutUs')">关于我们<div class="imgg"
							:class="path == '/aboutUs' ? '' : 'yincang'"></div>
					</div>
					<!-- <div class="hello">
						<div class="all1">
							<img width="220px" height="70px"
								src="https://dss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=2636368620,2367075435&fm=26&gp=0.jpg" />
							<div class="all11">
								<div @click="gotoweb('/aboutUs')">博软介绍</div>
								<div @click="gotoweb('/decoration')">团队风采</div>
							</div>
						</div>
					</div> -->

					<div class="header21" @click="gotoweb('/newsList')">新闻动态<div class="imgg"
							:class="path == '/newsList' ? '' : 'yincang'"></div>
					</div>
					<div class="header21" @click="gotoweb('/joinUs')">加入我们<div class="imgg"
							:class="path == '/joinUs' ? '' : 'yincang'"></div>
					</div>
					<!-- <div class="header21" @click="projectClick()">项目管理1</div> -->
					<div class="header21 PM">
						<a href="http://www.boruankeji.net/project" target="_blank">项目管理<div class="imgg"></div></a>
						<!-- <a href="#" target="_blank" @click="aClick">项目管理<div class="imgg"></div></a> -->
						<!-- <div @click="aClick">项目管理<div class="imgg"></div></div> -->
					</div>
				</div>
			</div>
			<div class="header3">
				<div class="header31">
					<img class="header311" src="../assets/img/phone.png" />
				</div>
				<div class="header32">
					<!-- <div class="header321">客户服务热线</div> -->
					<div class="header322">{{ this.jichuxinxi.contact }}</div>
				</div>
			</div>
			<!-- <div class="header4">
				<div class="headerflex">
					<div class="imgg" :class="path == '/index' ? '' : 'yincang'"></div>

					<div class="hello">
						<div class="all1">
							<img width="220px" height="70px"
								src="https://dss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=2636368620,2367075435&fm=26&gp=0.jpg" />
							<div class="all11">
								<div @click="gotoweb('/guanyu')">博软介绍</div>
								<div @click="gotoweb('/decoration')">团队风采</div>
							</div>
						</div>
					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
	export default {
		props: {},
		data() {
			return {
				isMobile: this.$store.state.isMobile === 1,
				path: "",
				jichuxinxi: "",
				urlHref: '',
			};
		},
		// html加载完成之前
		created() {
			this.urlHref = document.domain;
			console.log(this.urlHref, 'url11')
		},
		// html加载完成后执行。
		mounted() {
			this.path = this.$route.path;
			console.log("aa", this.$route.path);
			this.$get(this.$host + "/index/Home/getBaseInfo").then((res) => {
				console.log("基础信息", res);
				this.jichuxinxi = res.data;
			});
		},
		// 事件方法执行
		methods: {
			gotoweb(a) {
				this.$router.push(a);
			},
			// 点击进入项目管理
			projectClick() {
				// this.$router.replace({
				// 		path: '/staff/staffDetails',
				// 		// query: {
				// 		// 		id: row.staffId,
				// 		// },
				// })
			},
			aClick() {
				this.$router.push({
					path: this.urlHref + '/:60098/public/projectadmin'
				});
			},
		},
		// 计算属性
		computed: {},
		// 侦听器
		watch: {},
	};
</script>

<style lang="scss">
	// .guanyu:hover {

	// }
	.yincang {
		opacity: 0;
	}

	.allBody {
		width: 100%;

		.header {
			width: 100% !important;
			height: 90px !important;
			// background: #001228;
			display: flex;
			align-items: center;
			justify-content: space-between;
			cursor: pointer;
			position: fixed;
			top: 0;
			left: 0;
			z-index: 1000000001;

			.headerBg {
				position: absolute;
				top: 0;
				left: 0;
				width: 100vw !important;
				height: 90px !important;
				background: #001228;
				// background: red;
				z-index: -1;
				opacity: .5;
			}

			.header1 {
				.header11 {
					width: 160px;
					height: 40px;
					margin-left: 87px;
				}
			}

			.header2 {
				// position: absolute;
				// width: 50vw;
				// left: 25vw;

				// height: 70px;
				.header2flex {
					display: flex;
					justify-content: center;

					.header21 {
						margin-left: 5px;
						margin-right: 5px;
						width: 120px;
						display: flex;
						justify-content: center;
						flex: 1;
						font-size: 21px;
						font-weight: 400;
						color: #e8f2ff;
						z-index: 100;
						cursor: pointer;
						// padding: 0 20px;
						position: relative;

						a {
							margin-left: 5px;
							margin-right: 5px;
							width: 120px;
							display: flex;
							justify-content: center;
							flex: 1;
							font-size: 21px;
							font-weight: 400;
							color: #e8f2ff;
							z-index: 100;
							cursor: pointer;
							// font-size: 21px;
							color: #e8f2ff;

							.imgg {
								opacity: 0;
							}
						}
					}

					.header22 {
						display: flex;
						justify-content: center;
						flex: 1;
						font-size: 21px;
						font-weight: 400;
						color: #e8f2ff;
						z-index: 100;
						height: 100%;
					}

					.header22:hover+.hello {
						display: block;
					}

					.hello {
						position: absolute;
						display: none;

						.all1 {
							width: 100vw;
							height: 140px;
							background: #080222b7;
							margin-top: 48px;
							z-index: 100000;
							display: flex;
							align-items: center;
							justify-content: center;

							.all11 {
								font-size: 18px;
								font-family: Source Han Sans CN;
								font-weight: 300;
								color: #999999;
								line-height: 30px;
								margin-left: 20px;
							}
						}
					}

					.hello:hover {
						display: block;
					}
				}
			}

			.header3 {
				// width: 220px;
				// background: red;
				display: flex;
				margin-right: 99px;

				.header31 {
					display: flex;
					align-items: center;

					.header311 {
						width: 31px;
						height: 31px;
					}
				}

				.header32 {
					margin-left: 20px;
					display: flex;
					align-items: center;

					.header321 {
						font-size: 14px;
						// font-family: Source Han Sans CN;
						color: #8f6b19;
					}

					.header322 {
						font-size: 24px;
						// font-family: Source Han Sans CN;
						color: #fff;
					}
				}
			}

			.header4 {
				top: 30px;
				position: absolute;
				width: 50vw;
				left: 25vw;

				// right: 0;
				// text-align: center;
				.headerflex {
					display: flex;
					justify-content: center;

					.imgg {
						flex: 1;
						width: 100px;
						height: 40px;
					}
				}

				.guanyu:hover+.hello {
					display: block;
				}

				.hello {
					position: absolute;
					display: none;

					.all1 {
						width: 100vw;
						height: 140px;
						background: #080222b7;
						margin-top: 40px;
						z-index: 100000;
						display: flex;
						align-items: center;
						justify-content: center;

						img {}

						.all11 {
							font-size: 18px;
							font-family: Source Han Sans CN;
							font-weight: 300;
							color: #999999;
							line-height: 30px;
							margin-left: 20px;
						}
					}
				}

				.hello:hover {
					display: block;
				}
			}
		}

	}

	// .all1 {
	//   position: absolute;
	//   width: 100vw;
	//   height: 200px;
	//   background: cornflowerblue;
	//   margin-top: 50px;
	// }
</style>
